'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { DateTimeBlockRootContext } from './context/date-time-block-root.context';
import { dateTimeBlockWrapRecipe } from './styles/date-time-block-wrap.styles';
import type { DateTimeBlockWrapPropsInterface } from './types/date-time-block-wrap.types';

/**
 * `DateTimeBlock.Wrap.Outer` wraps and indents UI if pagination controls are visible
 *
 * @since 10.2.0
 */
export const DateTimeBlockWrap = forwardRef<HTMLDivElement, DateTimeBlockWrapPropsInterface>(
  (props: DateTimeBlockWrapPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const { includeOffset } = useContext(DateTimeBlockRootContext);

    const styles = css(dateTimeBlockWrapRecipe.raw({ includeOffset }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="DateTimeBlock.Wrap"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_date-time-block__wrap', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DateTimeBlockWrap.displayName = 'DateTimeBlock.Wrap';
